import { Injectable } from '@angular/core';
import {SupervisorService} from './supervisor.service';
import {ActivatedRouteSnapshot} from '@angular/router';

@Injectable()
export class SupervisorResolverService {

  constructor(private supervisorService: SupervisorService) { }

  resolve (route: ActivatedRouteSnapshot) {
    return this.supervisorService.getSupervisor(route.params['id']);
  }

}
